import { ChevronDown, ChevronUp, X } from "lucide-react";
import { Link } from "react-router";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";

export default function Sidebar({
  title,
  children,
  className,
}: {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="flex w-screen h-[calc(100vh-var(--spacing)*19)] overflow-scroll z-10 mt-19 ml-3">
      <Card
        className={`bg-card/80 backdrop-blur-sm border-muted self-start ${className || ""}`}
      >
        <CardHeader>
          <CardTitle className="text-2xl font-bold">
            <div className="flex flex-row justify-between space-x-6 items-center">
              <div>{title}</div>
              <div className="flex gap-2">
                <Button
                  variant="secondary"
                  size="icon"
                  onClick={() => setIsCollapsed(!isCollapsed)}
                >
                  {isCollapsed ? <ChevronDown /> : <ChevronUp />}
                </Button>
                <Link to="/">
                  <Button variant="secondary" size="icon">
                    <X />
                  </Button>
                </Link>
              </div>
            </div>
          </CardTitle>
        </CardHeader>
        {!isCollapsed && children}
      </Card>
      <div className="flex-1"></div>
    </div>
  );
}
